"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.capabilityQueryMock = exports.useCapabilities = void 0;
const client_1 = require("@apollo/client");
const socket_1 = require("@yanzi/socket");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const react_1 = require("react");
const CapabilityConfigurationProvider_1 = require("../components/CapabilityConfigurationProvider");
function useCapabilities({ ignoreDisabled = false, disabledCapabilities: optionsDisabledCapabilities = undefined, } = {}) {
    const { disabledCapabilities: defaultDisabledCapabilities } = react_1.useContext(CapabilityConfigurationProvider_1.CapabilityContext);
    const disabledCapabilities = optionsDisabledCapabilities !== null && optionsDisabledCapabilities !== void 0 ? optionsDisabledCapabilities : defaultDisabledCapabilities;
    const { data, loading, error } = client_1.useQuery(CAPABILITY_QUERY, {
        fetchPolicy: 'cache-first',
        context: { linkServer: true, suppressErrors: true },
    });
    react_1.useEffect(() => {
        var _a;
        if (error === null || error === void 0 ? void 0 : error.networkError) {
            if (!(error.networkError instanceof socket_1.CirrusError &&
                ((_a = error.networkError.response.responseCode) === null || _a === void 0 ? void 0 : _a.name) === 'errorAuthentication')) {
                if (process.env.NODE_ENV !== 'production') {
                    throw error.networkError;
                }
            }
        }
        else if (error) {
            if (process.env.NODE_ENV !== 'production') {
                throw error;
            }
        }
    }, [error]);
    const capabilities = react_1.useMemo(() => {
        var _a;
        return ((_a = data === null || data === void 0 ? void 0 : data.me.capabilities.filter(Boolean).filter(capability => ignoreDisabled || !disabledCapabilities.includes(capability))) !== null && _a !== void 0 ? _a : []);
    }, [data, disabledCapabilities, ignoreDisabled]);
    const has = react_1.useCallback((capability) => {
        return capabilities.includes(capability);
    }, [capabilities]);
    const some = react_1.useCallback((testCaps) => {
        return testCaps.some(val => capabilities.includes(val));
    }, [capabilities]);
    const someOrEmpty = react_1.useCallback((testCaps) => {
        return testCaps.length === 0 || some(testCaps);
    }, [some]);
    const all = react_1.useCallback((testCaps) => {
        return testCaps.every(val => capabilities.includes(val));
    }, [capabilities]);
    return react_1.useMemo(() => ({
        loading,
        capabilities,
        has,
        some,
        someOrEmpty,
        all,
    }), [loading, capabilities, has, some, someOrEmpty, all]);
}
exports.useCapabilities = useCapabilities;
const CAPABILITY_QUERY = graphql_tag_1.default `
  query CapabilityQuery {
    me {
      key
      capabilities
    }
  }
`;
function capabilityQueryMock(capabilities) {
    return {
        request: { query: CAPABILITY_QUERY, variables: {} },
        result: {
            data: {
                me: {
                    __typename: 'UserDTO',
                    key: 'jonas.dahl@yanzinetworks.com',
                    capabilities,
                },
            },
        },
    };
}
exports.capabilityQueryMock = capabilityQueryMock;
//# sourceMappingURL=useCapabilities.js.map